var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVueSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 39,
    viewBox: "0 0 50 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05698 6.58969e-08H1.66713C1.37388 -7.8156e-05 1.08579 0.069484 0.831969 0.201663C0.578144 0.333842 0.367562 0.523957 0.221486 0.752813C0.075411 0.981669 -0.000985888 1.24116 9.60578e-06 1.50509C0.0010051 1.76902 0.0793578 2.02804 0.227156 2.256L23.56 38.256C23.7068 38.4826 23.9169 38.6706 24.1696 38.8013C24.4223 38.932 24.7086 39.0008 25 39.0008C25.2914 39.0008 25.5777 38.932 25.8304 38.8013C26.0831 38.6706 26.2932 38.4826 26.44 38.256L49.7728 2.256C49.9206 2.02804 49.999 1.76902 50 1.50509C50.001 1.24116 49.9246 0.981669 49.7785 0.752813C49.6324 0.523957 49.4219 0.333842 49.168 0.201663C48.9142 0.069484 48.6261 -7.8156e-05 48.3329 6.58969e-08H40.943L25 23.916L9.05698 6.58969e-08Z",
    fill: "#21BF60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0565 0H27.3L25 4.146L22.6967 0H12.9436L25 18.084L37.0565 0Z",
    fill: "#21BF60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVueSvg);
export default __webpack_public_path__ + "static/media/VueSvg.7f590f0d1a1fe1e0eb6cf201a71acdd0.svg";
export { ForwardRef as ReactComponent };